/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'

import {login} from '../redux/AuthCRUD'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {AuthModel} from '../models/AuthModel'
import {KullaniciDto} from '../../../../lModel/Modeller'
import {setKullaniciDataAction} from '../../../../aStore/Store'
import {KullaniciLogin} from '../../../../lServis'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    //.email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  /*const KullaniciLogin = (kadi: string, sifre: string) => {
    if (kadi === 'admin@demo.com' && sifre === 'demo') {
      const kullanici: KullaniciDto = {
        GirisYapti: true,
        TokenStr: 'deneme',
        KullaniciId21: '123',
        TamAdi: 'Deneme',
        ResimYolu: '',
      }
      return kullanici
    } else {
      const kullanici: KullaniciDto = {
        GirisYapti: false,
        TokenStr: '',
        KullaniciId21: '',
        TamAdi: '',
        ResimYolu: '',
      }
      return kullanici
    }
  }*/

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
     // console.log('lgn0')
      const obj = await KullaniciLogin(values.email, values.password)
      setLoading(false)
      //console.log('lgn1', obj)
      if (!obj.Success) {
        setLoading(false)
        setSubmitting(false)
        setStatus('Kullanıcı bilgileri yanlış')
      }
      const klnData = {...obj.Data} as KullaniciDto
      //console.log('lgn2', klnData)
      if (klnData.TokenStr.length > 3) klnData.GirisYapti = true
      //const snc = login(values.email, values.password) as AuthModel

      if (klnData.GirisYapti) {
        setLoading(false)
        dispatch(setKullaniciDataAction(klnData))
        //todo //dispatch(auth.actions.login(snc.accessToken))
      } else {
        setLoading(false)
        setSubmitting(false)
        setStatus('Kullanıcı bilgileri yanlış')
      }
      /*setTimeout(() => {
        login(values.email, values.password)
          .then(({data: {accessToken}}) => {
            setLoading(false)
            dispatch(auth.actions.login(accessToken))
          })
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)*/
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>HDV Cenaze Fonu (V 3.1.1)</h1>
        <div className='text-gray-400 fw-bold fs-4'>Kullanıcı Giriş</div>
        
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div></div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Kullanıcı Adı</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Şifre</label>
            {/* end::Label */}
          </div>
        </div>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>GİRİŞ</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Lütfen bekleyiniz...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
